import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from "./components/Header";

import Home from "./components/Home";
import ContactForm from "./components/Contactform";
import Footer from "./components/Footer";
import Impressum from "./components/Impressum";

export default function App() {
  return (
    <><Router>
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/impressum" element={<Impressum/>} />
      </Routes>
      <Footer></Footer>
    </Router></>
  );
}
